import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HttpHeaderInterceptorService implements HttpInterceptor {
  /**
   * Get CSRF token - Django recommends reading from the csrftoken cookie for AJAX.
   * The cookie contains the canonical token; DOM may have a masked form.
   */
  private getCsrfToken(): string | null {
    const cookieToken = this.getCookie('csrftoken');
    if (cookieToken) return cookieToken;

    const csrfTokenElement = document.querySelector(
      '[name=csrfmiddlewaretoken]'
    ) as HTMLInputElement;
    const domToken = csrfTokenElement?.value?.trim();
    return domToken || null;
  }

  private getCookie(name: string): string | null {
    if (!document.cookie || document.cookie === '') return null;
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === name + '=') {
        return decodeURIComponent(cookie.substring(name.length + 1));
      }
    }
    return null;
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const csrfToken = this.getCsrfToken();
    if (!csrfToken) {
      return next.handle(req);
    }
    const modifiedReq = req.clone({
      setHeaders: {
        'X-CSRFToken': csrfToken,
      },
    });
    return next.handle(modifiedReq);
  }
}
